/** Mirrors public.gen_pairing_code(): no 0/O, 1/I/L. */
export const PAIRING_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const PAIRING_CODE_LENGTH = 6;

/** Mirrors public.normalize_pairing_code(). */
export function normalizeCode(input: string): string {
  return input.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

export function isValidCode(code: string): boolean {
  if (code.length !== PAIRING_CODE_LENGTH) return false;
  for (let i = 0; i < code.length; i++) if (PAIRING_ALPHABET.indexOf(code.charAt(i)) < 0) return false;
  return true;
}

/** "ABCDEF" → "ABC DEF" for display on a TV across the room. */
export function formatCode(code: string): string {
  return code.slice(0, 3) + ' ' + code.slice(3);
}

/** URL encoded in the TV's QR code. Opens the phone app (universal link) or the web pair page. */
export function pairUrl(base: string, code: string): string {
  return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'code=' + encodeURIComponent(code);
}

/** Accepts a scanned QR payload or a typed code; returns a valid normalised code or null. */
export function parsePairInput(input: string): string | null {
  const trimmed = input.trim();
  const m = /[?&]code=([A-Za-z0-9 -]+)/.exec(trimmed);
  const candidate = normalizeCode(m && m[1] ? m[1] : trimmed);
  return isValidCode(candidate) ? candidate : null;
}
